import { useState } from "react";
import { Mail, Phone, MapPin, ChevronDown, Clock } from "lucide-react";
import useSEO from "../hooks/useSEO";

const FAQ = [
  { q: "Welche Voraussetzungen benötige ich für die Anmietung?", a: "Mindestalter 21 Jahre, Führerschein Klasse B (mindestens 3 Jahre). Für Fahrzeuge über 3,5 t benötigen Sie die entsprechende Fahrerlaubnis." },
  { q: "Ist eine Versicherung im Preis enthalten?", a: "Ja, eine Vollkaskoversicherung mit 1500 € Selbstbeteiligung ist bereits im Grundpreis enthalten. Sie können die SB optional auf 0 € reduzieren." },
  { q: "Wie funktioniert die Übergabe?", a: "Abholung und Rückgabe erfolgen montags bis freitags von 9:00 bis 17:00 Uhr nach Terminvereinbarung an unserem Standort Taubenheimer Weg 3, 02742 Neusalza-Spremberg." },
  { q: "Kann ich meine Buchung stornieren?", a: "Kostenlose Stornierung bis 30 Tage vor Reiseantritt. Danach fallen gestaffelte Stornierungsgebühren an." },
  { q: "Sind Haustiere erlaubt?", a: "Hunde sind auf Anfrage erlaubt (Aufpreis 5 € / Nacht). Bitte teilen Sie uns dies im Voraus mit." },
];

export default function Contact() {
  const [open, setOpen] = useState(0);

  useSEO({
    title: "Kontakt & FAQ · Caravan Reisen Neusalza-Spremberg",
    description: "Nimm Kontakt mit Caravan Reisen auf: info@caravan-reisen.com, +49 (0)35872 / 6990-10. Öffnungszeiten Mo–Fr 9:00–17:00 Uhr in Neusalza-Spremberg. Antworten auf häufige Fragen zur Anmietung.",
    path: "/kontakt",
  });

  return (
    <div className="pt-32 pb-16 max-w-6xl mx-auto px-6 lg:px-10" data-testid="contact-page">
      <span className="chip">Kontakt & FAQ</span>
      <h1 className="section-title mt-4 text-5xl md:text-6xl">Wir helfen dir gerne.</h1>

      <div className="grid md:grid-cols-3 gap-6 mt-12">
        {[
          { i: Mail, l: "E-Mail", v: "info@caravan-reisen.com" },
          { i: Phone, l: "Telefon", v: "+49 (0)35872 / 6990-10" },
          { i: MapPin, l: "Adresse", v: "Taubenheimer Weg 3, 02742 Neusalza-Spremberg" },
        ].map((c, i) => (
          <div key={i} className="p-6 bg-white rounded-2xl border border-[#D8D6D0]">
            <c.i size={22} className="text-[#C05C42]" />
            <div className="text-xs uppercase tracking-wider text-[#1B2A22]/60 mt-4">{c.l}</div>
            <div className="font-semibold mt-1">{c.v}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-8 bg-white rounded-2xl border border-[#D8D6D0] flex flex-col md:flex-row md:items-center gap-6" data-testid="opening-hours">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-full bg-[#F0EFEA] flex items-center justify-center flex-shrink-0">
            <Clock size={22} className="text-[#C05C42]" />
          </div>
          <div>
            <div className="text-xs uppercase tracking-wider text-[#1B2A22]/60">Öffnungszeiten Abholung & Rückgabe</div>
            <div className="font-display font-semibold text-xl mt-1">Montag – Freitag · 9:00 – 17:00 Uhr</div>
          </div>
        </div>
        <div className="md:ml-auto text-sm text-[#1B2A22]/70 md:text-right">
          Taubenheimer Weg 3<br/>
          02742 Neusalza-Spremberg
        </div>
      </div>

      <div className="mt-20">
        <h2 className="section-title mb-8">Häufige Fragen.</h2>
        <div className="space-y-3">
          {FAQ.map((f, i) => (
            <div key={i} className="bg-white rounded-2xl border border-[#D8D6D0] overflow-hidden">
              <button
                className="w-full flex items-center justify-between p-6 text-left"
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`faq-${i}`}
              >
                <span className="font-display font-semibold">{f.q}</span>
                <ChevronDown size={20} className={`transition-transform ${open === i ? "rotate-180" : ""}`} />
              </button>
              {open === i && <div className="px-6 pb-6 text-[#1B2A22]/75 leading-relaxed">{f.a}</div>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
